import React from 'react';
import Hero, { HeroProps } from './Hero';
import SuccessSvg from './SuccessSvg';

export const Success: React.FunctionComponent<HeroProps> = (props) => {
    return (
        <Hero {...props}>
            <SuccessSvg />
        </Hero>
    );
};

Success.displayName = 'Success';
